import React, { Fragment, useEffect, useState } from "react";
import "./dashboard.scss";
import { useNavigate } from "react-router-dom";
import { Card, Modal } from "react-bootstrap";
import moment from "moment";
import {
    academyusergetdetail,
    admincountdashboard,
    listevent,
    monthfeelist,
    workerdashboardcount,
} from "../../services/admin";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { AgGridReact } from "ag-grid-react";
function Accountsdashboard() {
    const navigate = useNavigate();
    const [role, setRole] = useState("");
    const [academy, setAcademy] = useState("");
    const [wordet, setWorDet] = useState("");
    const [events, setEvents] = useState([]);
    const [olist, setOList] = useState("");
    const [nlist, setNList] = useState([]);

    const [fdate, setFDate] = useState("");
    const [todate, setToDate] = useState("");


    useEffect(() => {
        const today = new Date();
        const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        setFDate(moment(startDate).format("YYYY-MM-DD"));
        setToDate(moment(endDate).format("YYYY-MM-DD"));
        academyusergetdetail(localStorage.getItem("UID")).then((res) => {
            if (res.status === true) {
                setAcademy(res.data.details.academy_name);
                setRole(res.data.details.role_name);
            }
        });

        const temp = new FormData();
        temp.append("user_id", localStorage.getItem("UID"));
        temp.append("role_id", localStorage.getItem("Role"));
        workerdashboardcount(temp).then((res) => {
            if (res.status === true) {
                setNList(res.data);
                setWorDet(res.data.workers);
            }
        });

        setEvents([]);
        const temp1 = new FormData();
        temp1.append("academy_id", localStorage.getItem("academy"));
        listevent(temp1).then((res) => {
            if (res.status === true) {
                setEvents(res.data.details);
            }
        });

        const temp2 = new FormData();
        temp2.append("academy_id", localStorage.getItem("academy"));
        temp2.append("date", moment(new Date()).format("YYYY-MM-DD"));
        // temp2.append("date", '2025-03-07');
        admincountdashboard(temp2).then((res) => {
            if (res.status === true) {
                setOList(res.data);
            }
        });

        monthlylist(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"));
    }, []);
    const startAutoScroll = () => {
        const scrollContainer = document.getElementById("auto-scroll");
        const announcementList = document.getElementById("announcement-list");

        // Duplicate the list for seamless scrolling
        if (!announcementList.classList.contains("duplicated")) {
            const clone = announcementList.cloneNode(true);
            clone.id = "";
            clone.classList.add("duplicate");
            scrollContainer.appendChild(clone);
            announcementList.classList.add("duplicated");
        }

        const scrollSpeed = 1; // Pixels per step

        if (scrollContainer) {
            window.scrollInterval = setInterval(() => {
                scrollContainer.scrollTop += scrollSpeed;

                // Reset scroll position when reaching the end of the first list
                if (scrollContainer.scrollTop >= announcementList.scrollHeight) {
                    scrollContainer.scrollTop = 0;
                }
            }, 30); // Interval in milliseconds
        }
    };

    // Start auto-scrolling on page load
    document.addEventListener("DOMContentLoaded", startAutoScroll);
    const startBirthdayScroll = () => {
        const scrollContainer = document.getElementById("birthday-scroll");
        const birthdayList = document.getElementById("birthday-list");

        // Duplicate the list for seamless scrolling
        if (!birthdayList.classList.contains("duplicated")) {
            const clone = birthdayList.cloneNode(true);
            clone.id = "";
            clone.classList.add("duplicate");
            scrollContainer.appendChild(clone);
            birthdayList.classList.add("duplicated");
        }

        const scrollSpeed = 1; // Pixels per step

        if (scrollContainer) {
            window.scrollInterval = setInterval(() => {
                scrollContainer.scrollTop += scrollSpeed;

                // Reset scroll position when reaching the end of the first list
                if (scrollContainer.scrollTop >= birthdayList.scrollHeight) {
                    scrollContainer.scrollTop = 0;
                }
            }, 30); // Interval in milliseconds
        }
    };

    // Start auto-scrolling on page load
    document.addEventListener("DOMContentLoaded", startBirthdayScroll);

    const [ashow, setAShow] = useState(false);
    const [anndet, setAnnDet] = useState("");
    function handleView(hdata) {
        setAnnDet(hdata);
        setAShow(true);
    }

    function handleAClose() {
        setAShow(false);
        setAnnDet("");
    }

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState("");
    const openModal = (event) => {
        setSelectedEvent(event);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setSelectedEvent("");
        setModalIsOpen(false);
    };

    const handleEventClick = (info) => {
        const clickedEvent = {
            title: info.event.title,
            start: info.event.start,
            end: info.event.end,
            description: info.event.extendedProps.description,
            location: info.event.extendedProps.location,
            circular:
                info.event.extendedProps.circular === ""
                    ? ""
                    : info.event.extendedProps.path + info.event.extendedProps.circular,
        };
        openModal(clickedEvent);
    };

    const [filterProduct, setFilterProduct] = useState([]);
    function monthlylist(fdte, tdte) {
        setFDate(fdte);
        setToDate(tdte);
        setFilterProduct([]);
        const temp = new FormData();
        temp.append("academy_id", localStorage.getItem("academy"));
        temp.append("from_date", fdte);
        temp.append("to_date", tdte);
        monthfeelist(temp).then((res) => {
            if (res.status === true) {
                const fdata=res.data.map((item) => ({
                    ...item,
                    paid_date: moment(item.paid_date).format("DD-MM-YYYY"),
                }))
                setFilterProduct(fdata);
            }
        });
    }

    const columnDefs = [
        {
            headerName: "Payment Date",
            field: "paid_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
          },
        {
          headerName: "Student Name",
          field: "student_name",
          sortable: true,
          resizable: true,
          filter: true,
          floatingFilter: true,
          cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Class",
            field: "class_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
          },
          {
            headerName: "Section",
            field: "section_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
          },
          {
            headerName: "Fee Type",
            field: "fee_type",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
          },
          {
            headerName: "Total Fee",
            field: "total_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
          },
          {
            headerName: "Paid Fee",
            field: "paid_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
          },
          {
            headerName: "Pending Fee",
            field: "pending_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
          },
      ];
    
    return (
        <Fragment>
            <div className="main-container container-fluid">
                <div className="inner-body">
                    {/* Page Header */}
                    <div className="page-header">
                        <h2 className="main-content-title tx-24 mg-b-5">
                            Welcome To Dashboard
                        </h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a>Home</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Dashboard
                            </li>
                        </ol>
                    </div>
                    {/* End Page Header */}
                    {/*Row*/}
                    <div className="row row-sm">
                        <div className="col-sm-12 col-lg-12 col-xl-8">
                            {/*Row*/}
                            <div className="row row-sm  mt-lg-4">
                                <div className="col-sm-12 col-lg-12 col-xl-12">
                                    <div className="bg-black-2 custom-card card-box card">
                                        <div className="card-body p-4">
                                            <div className="row align-items-center">
                                                <div className="offset-xl-3 offset-sm-6 col-xl-8 col-sm-6 col-12 img-bg ">
                                                    <h4 className="d-flex  mb-3">
                                                        <span className="font-weight-bold text-white ">
                                                            {localStorage.getItem("Role") == 1
                                                                ? "AMY Technologies Public School"
                                                                : `${academy}`}
                                                        </span>
                                                    </h4>
                                                    <p className="tx-white-7 mb-1">
                                                        Welcome Back{" "}
                                                        <b className="text-warning">
                                                            {localStorage.getItem("Role") == 1
                                                                ? "Accountant"
                                                                : `${role}`}
                                                        </b>{" "}
                                                        See our Todays Dashboard{" "}
                                                        <b className="text-warning">
                                                            {moment(new Date()).format("DD-MM-YYYY")}
                                                        </b>
                                                        <br></br>
                                                        Have a Nice Day
                                                    </p>
                                                </div>
                                                <img
                                                    src={require("../../assets/images/dashboard/accountant.png")}
                                                    alt="Student"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*Row */}
                            {/*Row*/}
                            <div className="col-sm-12 col-lg-12 col-xl-12">
                                <div className="row row-sm">
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="card custom-card student-card">
                                            <div className="card-body">
                                                <div className="card-order ">
                                                    <label className="main-content-label student-name-card mb-3 pt-1">
                                                        My Unique Number
                                                    </label>
                                                    <h2 className="text-end card-item-icon card-icon tx-18">
                                                        <i className="fa fa-user-circle-o icon-size float-start text-primary"></i>
                                                        <span className="student-no font-weight-bold ">
                                                            {wordet ? wordet.username : ""}
                                                        </span>
                                                    </h2>
                                                    {/* <p className="mb-0 text-muted">Ajithkumar<span className="float-end">XX - A</span></p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="card custom-card student-card">
                                            <div className="card-body">
                                                <div className="card-order ">
                                                    <label className="main-content-label student-name-card mb-3 pt-1">
                                                        Employee ID
                                                    </label>
                                                    <h2 className="text-end card-item-icon card-icon">
                                                        <i className="fa fa-user icon-size float-start text-primary"></i>
                                                        <span className="student-no font-weight-bold">
                                                            {wordet ? wordet.employee_id : ""}
                                                        </span>
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="card custom-card student-card">
                                            <div className="card-body">
                                                <div className="card-order ">
                                                    <label className="main-content-label student-name-card mb-3 pt-1">
                                                        Today Admission Enquiry
                                                    </label>
                                                    <h2 className="text-end card-item-icon card-icon">
                                                        <i className="fa fa-user-plus icon-size float-start text-primary"></i>
                                                        <span className="student-no font-weight-bold">
                                                            {olist ? olist.enquiry.today_enquiry : "0"}
                                                        </span>
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-lg-12 col-xl-12">
                                <div className="row row-sm">
                                    <div className="col-md-6 col-xl-6">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a>TEACHERS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-4 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>
                                                            {olist ? olist.teachers.total_teachers : "0"}
                                                        </a>{" "}
                                                        <p className="text-muted ">Total</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>
                                                            {olist ? olist.teachers.active_teachers : "0"}
                                                        </a>{" "}
                                                        <p className="text-muted ">Active </p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>
                                                            {olist ? olist.teachers.left_teachers : "0"}
                                                        </a>{" "}
                                                        <p className="text-muted ">Left</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-6">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a>WORKERS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>
                                                            {olist ? olist.workers.total_workers : "0"}
                                                        </a>{" "}
                                                        <p className="text-muted ">Total</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>
                                                            {olist ? olist.workers.active_workers : "0"}
                                                        </a>{" "}
                                                        <p className="text-muted ">Active</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-6">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a>STUDENTS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-4 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>
                                                            {olist ? olist.students.active_students : "0"}
                                                        </a>{" "}
                                                        <p className="text-muted ">Total </p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>
                                                            {olist ? olist.students.active_students : "0"}
                                                        </a>{" "}
                                                        <p className="text-muted ">Active</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>
                                                            {olist ? olist.students.active_students : "0"}
                                                        </a>{" "}
                                                        <p className="text-muted ">Left</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy III-st">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >FEE OVERVIEW</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-4 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>0</a>{" "}
                                                        <p className="text-muted ">Paid </p>
                                                    </h3>

                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>0</a>{" "}
                                                        <p className="text-muted ">Unpaid</p>
                                                    </h3>

                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>0</a>{" "}
                                                        <p className="text-muted ">Partial</p>
                                                    </h3>

                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="col-md-6 col-xl-6">
                                        <div className="card custom-card">
                                            <div className="card-bodyy V-st">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a>ACCOUNTS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>₹ {olist ? olist.incomedet : "0"}</a>{" "}
                                                        <p className="text-muted ">Income</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>₹ {olist ? olist.expensedet : "0"}</a>{" "}
                                                        <p className="text-muted">Expenses</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy II-st">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >EXPENSES</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >₹ 456</a>{" "}
                                                        <p className="text-muted ">Today</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >₹ 556</a>{" "}
                                                        <p className="text-muted ">Total</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                            {/*End row*/}
                            {/*row*/}
                            <div className="row row-sm">
                                <div className="col-lg-12">
                                    <div className="card custom-card mg-b-20">
                                        <Card className="custom-card">
                                            <Card.Header className="">
                                                <div className="d-md-flex ms-auto">
                                                    <label className="main-content-label my-auto pt-2">
                                                        <i className="fa fa-money headericons"></i> Monthly
                                                        Fee Collections
                                                    </label>

                                                </div>
                                            </Card.Header>
                                            <Card.Body>
                                                <div className="row">
                                                    <div className="col-xl-6 col-sm-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                From Date<span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={fdate}
                                                                onChange={(e) => monthlylist(e.target.value, todate)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-6 col-sm-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                To Date<span className="text-danger"> *</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={todate}
                                                                onChange={(e) => monthlylist(fdate, e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="ag-theme-alpine ag-style mt-2">
                                                    <AgGridReact
                                                        columnDefs={columnDefs}
                                                        rowData={filterProduct}
                                                        pagination="true"
                                                        paginationPageSize="10"
                                                        sortingOrder={["asc", "desc"]}
                                                        suppressDragLeaveHidesColumns={true}
                                                    />
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </div>
                                <div
                                    className="col-sm-12 col-md-12 col-lg-6 col-xl-6"
                                    data-wow-delay="1.5s"
                                >
                                    <Card className="custom-card">
                                        <Card.Header>
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2">
                                                    <i className="fa fa-bullhorn headericons"></i>{" "}
                                                    Announcement
                                                </label>
                                            </div>
                                        </Card.Header>
                                        <Card.Body
                                            id="auto-scroll"
                                            onMouseEnter={() => clearInterval(window.scrollInterval)}
                                            // onMouseLeave={startAutoScroll}
                                            style={{
                                                maxHeight: "350px",
                                                overflow: "hidden",
                                                position: "relative",
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <ul
                                                className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                id="announcement-list"
                                            >
                                                {nlist &&
                                                    nlist.notification &&
                                                    nlist.notification.length > 0 ? (
                                                    nlist.notification.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className="d-flex align-items-center mb-3"
                                                        >
                                                            <div className="flex-shrink-0">
                                                                <div className="main-avatar avatar-md online"></div>
                                                            </div>
                                                            <div className="ms-3 flex-grow-1">
                                                                <p className="tx-16 text-dark mb-0 tx-semibold">
                                                                    {item.title}
                                                                </p>
                                                                <p className="mb-0 text-muted tx-16">
                                                                    {moment(item.created_at).format("DD-MM-YYYY")}
                                                                </p>
                                                            </div>
                                                            <a
                                                                className="me-2 mt-1"
                                                                onClick={() => handleView(item)}
                                                            >
                                                                <span className="badge bg-success-light">View</span>
                                                            </a>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <h6>No Announcement found.</h6>
                                                )}
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div
                                    className="col-sm-12 col-md-12 col-lg-6 col-xl-6"
                                    data-wow-delay="1.5s"
                                >
                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2">
                                                    <i className="mdi mdi-account-check headericons"></i>{" "}
                                                    Staff Attendance
                                                </label>
                                            </div>
                                        </Card.Header>
                                        <Card.Body
                                            id="birthday-scroll"
                                            onMouseEnter={() => clearInterval(window.scrollInterval)}
                                            // onMouseLeave={startBirthdayScroll}
                                            style={{
                                                maxHeight: "350px",
                                                overflow: "hidden",
                                                position: "relative",
                                            }}
                                        >
                                            <ul
                                                className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                id="birthday-list"
                                            >
                                                {olist && olist.staffattendance && olist.staffattendance.length > 0 ? (
                                                    olist.staffattendance.map((item, index) => (
                                                        <li key={index} className="media d-flex mb-3 mt-0 pt-0">
                                                            <img
                                                                alt="avatar"
                                                                className="me-3 rounded-circle avatar avatar-md"
                                                                src={item.photo !== null ? olist.path + item.photo : require("../../assets/images/teacher.jpg")}
                                                            />
                                                            <div className="media-body mb-1 announcement">
                                                                <div className="float-end">
                                                                    {item.attend_status == 1 ? <button className="btn btn-success btn-sm">P</button> : <button className="btn btn-danger btn-sm">A</button>}

                                                                </div>
                                                                <h5 className="media-title tx-16 mb-0">
                                                                    {item.teacher_name}
                                                                </h5>
                                                                <p className="mb-0 tx-13 text-muted">
                                                                    {`${item.class_name} - ${item.section_name}`}
                                                                </p>
                                                            </div>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <h6>No Staff Attendance found.</h6>
                                                )}

                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>

                                {/* col end */}
                            </div>
                            {/* Row end */}
                        </div>
                        {/* col end */}

                        <div className="col-sm-12 col-lg-12 col-xl-4">
                            <div className="card custom-card mg-t-30">
                                <Card className="custom-card">
                                    <Card.Header className="">
                                        <div className="d-md-flex ms-auto">
                                            <label className="main-content-label my-auto pt-2">
                                                <i className="fa fa-calendar headericons"></i> Events
                                                calendar
                                            </label>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        <FullCalendar
                                            plugins={[dayGridPlugin]}
                                            initialView="dayGridMonth"
                                            events={events.map((event) => ({
                                                title: event.event_name,
                                                start: event.event_start,
                                                end: event.event_end || event.event_start,
                                                description: event.description,
                                                location: event.location,
                                                path: event.path,
                                                circular: event.circular,
                                                backgroundColor: "#b04751",
                                                textColor: "#fff",
                                            }))}
                                            eventClick={handleEventClick}
                                        />
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className="card custom-card mg-t-30">
                                <Card className="custom-card">
                                    <Card.Header className="">
                                        <div className="d-md-flex ms-auto">
                                            <label className="main-content-label my-auto pt-2">
                                                <i className="fa fa-plus-square headericons"></i>{" "}
                                                Overall Income
                                            </label>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        {
                                            olist && olist.incomeexpence && olist.incomeexpence.length > 0 ? (
                                                // Filter the items where head_type is 2
                                                (() => {
                                                    const filteredItems = olist.incomeexpence.filter(item => item.head_type === 1);
                                                    return filteredItems.length > 0 ? (
                                                        filteredItems.map((item, index) => (
                                                            <li key={index} className="d-flex align-items-center mb-3">
                                                                <div className="flex-shrink-0">
                                                                    <div className="main-avatar avatar-md online"></div>
                                                                </div>
                                                                <div className="ms-3 flex-grow-1">
                                                                    <p className="tx-16 text-dark mb-0 tx-semibold">{item.name}</p>
                                                                    <p className="mb-0 text-muted tx-16">{item.inv_no} - {moment(item.inv_date).format('DD-MM-YYYY')}</p>
                                                                </div>
                                                                <a className="me-2 mt-1">
                                                                    <span className="badge bg-success-light">{item.amount}</span>
                                                                </a>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <h6>No Overall Income found.</h6>
                                                    );
                                                })()
                                            ) : (
                                                <h6>No Overall Income found.</h6>
                                            )
                                        }

                                    </Card.Body>
                                </Card>
                            </div>
                            <div className="card custom-card mg-t-30">
                                <Card className="custom-card">
                                    <Card.Header className="">
                                        <div className="d-md-flex ms-auto">
                                            <label className="main-content-label my-auto pt-2">
                                                <i className="fa fa-minus-square headericons"></i>{" "}
                                                Overall Expenses
                                            </label>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        {
                                            olist && olist.incomeexpence && olist.incomeexpence.length > 0 ? (
                                                // Filter the items where head_type is 2
                                                (() => {
                                                    const filteredItems = olist.incomeexpence.filter(item => item.head_type === 2);
                                                    return filteredItems.length > 0 ? (
                                                        filteredItems.map((item, index) => (
                                                            <li key={index} className="d-flex align-items-center mb-3">
                                                                <div className="flex-shrink-0">
                                                                    <div className="main-avatar avatar-md online"></div>
                                                                </div>
                                                                <div className="ms-3 flex-grow-1">
                                                                    <p className="tx-16 text-dark mb-0 tx-semibold">{item.name}</p>
                                                                    <p className="mb-0 text-muted tx-16">{item.inv_no} - {moment(item.inv_date).format('DD-MM-YYYY')}</p>
                                                                </div>
                                                                <a className="me-2 mt-1">
                                                                    <span className="badge bg-success-light">{item.amount}</span>
                                                                </a>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <h6>No Overall Expenses found.</h6>
                                                    );
                                                })()
                                            ) : (
                                                <h6>No Overall Expenses found.</h6>
                                            )
                                        }


                                    </Card.Body>
                                </Card>
                            </div>
                        </div>

                        {/* col end */}
                    </div>

                    <Modal show={ashow} onHide={handleAClose}>
                        <Modal.Header>
                            <Modal.Title>Announcement Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>Title</label>
                                            </div>
                                            <div className="col-md-8">
                                                <a>{anndet.title}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>Message</label>
                                            </div>
                                            <div className="col-md-8">
                                                <a>{anndet.message}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <a className="btn btn-secondary" onClick={handleAClose}>
                                Close
                            </a>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={modalIsOpen} size="md">
                        <Modal.Header>
                            <Modal.Title>Events</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="table-responsive">
                                <h4>{selectedEvent.title}</h4>
                                <p>
                                    <strong>Start Date :</strong>{" "}
                                    {moment(selectedEvent.start).format("DD-MM-YYYY")}
                                </p>
                                <p>
                                    <strong>End Date :</strong>{" "}
                                    {moment(selectedEvent.end).format("DD-MM-YYYY")}
                                </p>
                                <p>
                                    <strong>Location :</strong> {selectedEvent.location}
                                </p>
                                <p>
                                    <strong>Description :</strong> {selectedEvent.description}
                                </p>
                                {selectedEvent.circular !== "" && (
                                    <p>
                                        <strong>Circular:</strong>{" "}
                                        <a
                                            href={selectedEvent.circular}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            View Circular
                                        </a>
                                    </p>
                                )}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <a className="btn btn-info" onClick={closeModal}>
                                Close
                            </a>
                        </Modal.Footer>
                    </Modal>

                    {/* Row end */}
                </div>
            </div>
        </Fragment>
    );
}

Accountsdashboard.propTypes = {};

Accountsdashboard.defaultProps = {};

export default Accountsdashboard;
